<template>
  <div class="admin-container">
    <!-- Sidebar Navigation -->
    <aside
      class="sidebar"
      :class="{ 'mobile-open': isSidebarOpen, collapsed: !isSidebarOpen }"
    >
      <div class="brand">
        <div class="brand-text">
          <span class="brand-first">Cochin</span>
          <span class="brand-second">Distributors</span>
        </div>
        <img :src="logo" alt="Logo" class="brand-logo-img" />
      </div>

      <div class="sidebar-user">
        <div class="avatar">A</div>
        <div class="user-info">
          <span class="name">Administrator</span>
          <span class="role">Super Admin <span class="status-dot"></span></span>
        </div>
      </div>

      <nav class="nav-menu">
        <div class="nav-section">
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'dashboard' }"
            @click.prevent="selectMenu('dashboard')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
            </span>
            <span class="nav-text">Dashboard</span>
          </a>
        </div>

        <div class="nav-section">
          <span class="nav-section-title">Catalog</span>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'addProduct' }"
            @click.prevent="openAddProductModal"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="16" />
                <line x1="8" y1="12" x2="16" y2="12" />
              </svg>
            </span>
            <span class="nav-text">Add Product</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'listProducts' }"
            @click.prevent="selectMenu('listProducts')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                />
              </svg>
            </span>
            <span class="nav-text">Product List</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'addCategory' }"
            @click.prevent="selectMenu('addCategory')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                />
                <line x1="7" y1="7" x2="7.01" y2="7" />
              </svg>
            </span>
            <span class="nav-text">Categories</span>
          </a>
        </div>

        <div class="nav-section">
          <span class="nav-section-title">Operations</span>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'staffManagement' }"
            @click.prevent="selectMenu('staffManagement')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
            <span class="nav-text">Staff</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'orders' }"
            @click.prevent="selectMenu('orders')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path
                  d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                />
              </svg>
            </span>
            <span class="nav-text">Orders</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'approve-leaves' }"
            @click.prevent="selectMenu('approve-leaves')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </span>
            <span class="nav-text">Leaves</span>
            <span v-if="pendingLeaves > 0" class="badge-pill">{{
              pendingLeaves
            }}</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'chat' }"
            @click.prevent="selectMenu('chat')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                />
              </svg>
            </span>
            <span class="nav-text">Messages</span>
            <span v-if="unreadMessageCount > 0" class="badge-pill">{{
              unreadMessageCount
            }}</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'tracking' }"
            @click.prevent="selectMenu('tracking')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="10" r="3" />
                <path
                  d="M12 2a8 8 0 0 0-8 8c0 5.25 8 13 8 13s8-7.75 8-13a8 8 0 0 0-8-8z"
                />
              </svg>
            </span>
            <span class="nav-text">Tracking</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'reviews' }"
            @click.prevent="selectMenu('reviews')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                />
              </svg>
            </span>
            <span class="nav-text">Reviews</span>
          </a>
        </div>

        <div class="nav-section">
          <span class="nav-section-title">Analysis</span>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'attendance' }"
            @click.prevent="selectMenu('attendance')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </span>
            <span class="nav-text">Attendance</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'attendance-analysis' }"
            @click.prevent="selectMenu('attendance-analysis')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
              </svg>
            </span>
            <span class="nav-text">Analysis</span>
          </a>
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'algorithm-comparison' }"
            @click.prevent="selectMenu('algorithm-comparison')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
              </svg>
            </span>
            <span class="nav-text">Algorithms</span>
          </a>
        </div>

        <div class="nav-section">
          <a
            href="#"
            class="nav-item"
            :class="{ active: selectedMenu === 'changePassword' }"
            @click.prevent="selectMenu('changePassword')"
          >
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            <span class="nav-text">Security</span>
          </a>
          <a href="#" class="nav-item logout" @click.prevent="logout">
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </span>
            <span class="nav-text">Logout</span>
          </a>
        </div>
      </nav>
    </aside>

    <div
      class="sidebar-overlay"
      :class="{ active: isSidebarOpen }"
      @click="isSidebarOpen = false"
    ></div>

    <!-- Main Content Area -->
    <main class="main-content">
      <!-- Top Header -->
      <header class="top-header">
        <div class="header-left">
          <button
            class="sidebar-toggle"
            @click="isSidebarOpen = !isSidebarOpen"
          >
            ☰
          </button>
        </div>
      </header>

      <!-- Content Views -->
      <div class="content-wrapper">
        <!-- Dashboard View -->
        <div v-if="selectedMenu === 'dashboard'" class="dashboard-view">
          <div class="dashboard-header">
            <div class="breadcrumb">🏠 Dashboard Overview</div>
          </div>

          <!-- Stats Cards (Main Row) -->
          <div class="stats-grid">
            <div class="stat-card gradient-danger">
              <div class="stat-label">
                <span>Total Revenue</span>
                <span class="stat-icon">💰</span>
              </div>
              <div class="stat-value">
                ₹{{ totalPurchases.toLocaleString() }}
              </div>
              <div class="stat-subtext">Cumulative Sales</div>
            </div>
            <div class="stat-card gradient-primary">
              <div class="stat-label">
                <span>Active Orders</span>
                <span class="stat-icon">🛒</span>
              </div>
              <div class="stat-value">{{ totalOrders || 0 }}</div>
              <div class="stat-subtext">Proccessing now</div>
            </div>
            <div class="stat-card gradient-success">
              <div class="stat-label">
                <span>Total Profit</span>
                <span class="stat-icon">📈</span>
              </div>
              <div class="stat-value">₹{{ totalProfit.toLocaleString() }}</div>
              <div class="stat-subtext">Cumulative Profit</div>
            </div>
            <div class="stat-card gradient-info">
              <div class="stat-label">
                <span>Staff Present</span>
                <span class="stat-icon">👥</span>
              </div>
              <div class="stat-value">{{ activeStaff }} / {{ totalStaff }}</div>
              <div class="stat-subtext">Real-time attendance</div>
            </div>
          </div>

          <!-- Secondary Stats Row (New) -->
          <div class="stats-grid mt-4">
            <div class="stat-card mini white">
              <div class="stat-label">📦 Total Products</div>
              <div class="stat-value dark">{{ totalProducts }}</div>
            </div>
            <div class="stat-card mini white">
              <div class="stat-label">🏗️ Total Inventory</div>
              <div class="stat-value dark">{{ totalInventory }}</div>
            </div>
            <div class="stat-card mini white">
              <div class="stat-label">⏳ Pending Leaves</div>
              <div class="stat-value dark">{{ pendingLeaves }}</div>
            </div>
            <div class="stat-card mini white">
              <div class="stat-label">📧 Enquiries</div>
              <div class="stat-value dark">{{ totalEnquiries || 0 }}</div>
            </div>
          </div>

          <!-- Component: Expiry Alerts Section -->
          <div
            v-if="expiringProducts.length > 0 || expiredCount > 0"
            class="expiry-alerts-wrapper mt-4"
          >
            <div
              class="section-card alert-section"
              :class="{ 'has-expired': expiredCount > 0 }"
            >
              <div
                class="alert-banner"
                :class="expiredCount > 0 ? 'danger' : 'warning'"
              >
                <div class="alert-info">
                  <span class="alert-icon">{{
                    expiredCount > 0 ? "🚫" : "⚠️"
                  }}</span>
                  <div class="alert-text">
                    <strong v-if="expiredCount > 0"
                      >{{ expiredCount }} Products have EXPIRED!</strong
                    >
                    <strong v-else
                      >{{ expiringProducts.length }} Products expiring soon
                      (within 10 days).</strong
                    >
                    <p>Immediate action recommended to manage inventory.</p>
                  </div>
                </div>
                <button
                  class="btn-toggle-alerts"
                  @click="showExpiryDetails = !showExpiryDetails"
                >
                  {{ showExpiryDetails ? "Close Alerts" : "Manage Now" }}
                </button>
              </div>

              <div v-if="showExpiryDetails" class="expiry-details-list">
                <div
                  v-for="p in expiringProducts"
                  :key="p._id"
                  class="expiry-item"
                >
                  <div class="item-main">
                    <img
                      :src="getImageUrl(p.image || p.imageFront)"
                      class="mini-prod-img"
                    />
                    <div class="item-meta">
                      <span class="item-name">{{ p.name }}</span>
                      <span class="item-date"
                        >Expires:
                        {{ new Date(p.expiryDate).toLocaleDateString() }}</span
                      >
                    </div>
                  </div>
                  <div class="item-actions">
                    <span class="badge warning">Expiring</span>
                    <button
                      class="btn-manage-alert"
                      @click="openEditProductModal(p._id)"
                    >
                      Edit
                    </button>
                  </div>
                </div>
                <!-- Also show expired ones in this list if they exist -->
              </div>
            </div>
          </div>

          <!-- Charts Grid -->
          <div class="charts-grid mt-4">
            <div class="section-card">
              <div class="section-header">
                <h3>📊 Sales & Profit Breakdown</h3>
                <div class="analytics-controls">
                  <div class="time-filter">
                    <select
                      v-model="chartTimeframe"
                      @change="handleTimeframeChange"
                      class="chart-select"
                    >
                      <option value="today">Today</option>
                      <option value="weekly">This Week</option>
                      <option value="monthly">This Month</option>
                      <option value="yearly">This Year</option>
                      <option value="custom">Custom Range</option>
                    </select>
                    <div
                      v-if="chartTimeframe === 'custom'"
                      class="date-range-inputs"
                    >
                      <input
                        type="date"
                        v-model="customStartDate"
                        @change="handleTimeframeChange"
                        class="date-picker-input"
                      />
                      <span>to</span>
                      <input
                        type="date"
                        v-model="customEndDate"
                        @change="handleTimeframeChange"
                        class="date-picker-input"
                      />
                    </div>
                  </div>
                  <button
                    @click="downloadReport"
                    class="btn-download"
                    :disabled="reportLoading"
                  >
                    <span v-if="reportLoading">Generating...</span>
                    <span v-else>📥 Download Report</span>
                  </button>
                </div>
              </div>
              <div class="analytics-table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Qty Sold</th>
                      <th>Revenue (₹)</th>
                      <th>Profit (₹)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in analyticsData?.productBreakdown || []"
                      :key="item.name"
                    >
                      <td>{{ item.name }}</td>
                      <td>{{ item.unitsSold }}</td>
                      <td>{{ item.revenue.toLocaleString() }}</td>
                      <td>{{ item.profit.toLocaleString() }}</td>
                    </tr>
                    <tr v-if="!analyticsData?.productBreakdown?.length">
                      <td colspan="4" class="empty-msg">
                        No sales data for this period.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="section-card top-products-card">
              <div class="section-header">
                <h3>🏆 Top Selling Products</h3>
                <span class="live-badge">● LIVE</span>
              </div>
              <div class="top-products-list">
                <div v-if="topProductsLoading" class="tp-loading">
                  Loading...
                </div>
                <div v-else-if="topProducts.length === 0" class="tp-empty">
                  No sales data yet.
                </div>
                <div v-else>
                  <div
                    v-for="(product, index) in topProducts"
                    :key="product._id"
                    class="tp-item"
                  >
                    <div class="tp-rank">{{ index + 1 }}</div>
                    <img
                      :src="getImageUrl(product.image)"
                      :alt="product.name"
                      class="tp-img"
                      @error="
                        $event.target.src =
                          'https://via.placeholder.com/48x48/f1f5f9/94a3b8?text=N%2FA'
                      "
                    />
                    <div class="tp-info">
                      <div class="tp-name">{{ product.name }}</div>
                      <div class="tp-revenue">
                        ₹{{ Number(product.revenue || 0).toLocaleString() }}
                      </div>
                    </div>
                    <div class="tp-units-badge">
                      <span class="tp-units">{{ product.unitsSold }}</span>
                      <span class="tp-units-label">units</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Overview Table -->
          <div class="dashboard-sections">
            <div class="section-card" style="width: 100%">
              <div class="section-header">
                <h3>📦 Product Overview</h3>
                <span
                  v-if="productOverviewLoading"
                  style="font-size: 0.8rem; color: #64748b"
                  >Loading...</span
                >
              </div>
              <div class="analytics-table-container" style="height: 350px">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product Name</th>
                      <th>Total Qty</th>
                      <th>Sold Qty</th>
                      <th>Balance Qty</th>
                      <th>MFD</th>
                      <th>Expiry</th>
                      <th>Selling Price (₹)</th>
                      <th>Profit Gained (₹)</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(p, idx) in productOverview"
                      :key="p._id"
                      :class="{ 'row-expired': p.isExpired }"
                    >
                      <td>{{ idx + 1 }}</td>
                      <td>{{ p.name }}</td>
                      <td>{{ p.totalQty }}</td>
                      <td>{{ p.soldQty }}</td>
                      <td>{{ p.balanceQty }}</td>
                      <td>
                        {{
                          p.manufacturingDate
                            ? new Date(p.manufacturingDate).toLocaleDateString(
                                "en-IN"
                              )
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          p.expiryDate
                            ? new Date(p.expiryDate).toLocaleDateString("en-IN")
                            : "-"
                        }}
                      </td>
                      <td>
                        ₹{{ Number(p.sellingPrice || 0).toLocaleString() }}
                      </td>
                      <td>
                        ₹{{ Number(p.profitGained || 0).toLocaleString() }}
                      </td>
                      <td>
                        <span
                          :class="
                            p.isExpired
                              ? 'status-badge danger'
                              : 'status-badge success'
                          "
                        >
                          {{ p.isExpired ? "Expired" : "Active" }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-if="!productOverview.length && !productOverviewLoading"
                    >
                      <td colspan="10" class="empty-msg">No products found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Other Views -->
        <AddProduct v-if="selectedMenu === 'addProduct'" />
        <ProductCategory v-if="selectedMenu === 'addCategory'" />
        <ProductList
          v-if="selectedMenu === 'listProducts'"
          @edit="openEditProductModal"
        />
        <StaffManagement v-if="selectedMenu === 'staffManagement'" />
        <AdminOrders v-if="selectedMenu === 'orders'" />
        <AdminLeaves v-if="selectedMenu === 'approve-leaves'" />
        <ChatWindow v-if="selectedMenu === 'chat'" />
        <LiveTracking v-if="selectedMenu === 'tracking'" />
        <AdminAttendance v-if="selectedMenu === 'attendance'" />
        <AttendanceAnalysis v-if="selectedMenu === 'attendance-analysis'" />
        <AlgorithmComparison v-if="selectedMenu === 'algorithm-comparison'" />

        <!-- Reviews View -->
        <div v-if="selectedMenu === 'reviews'" class="reviews-section">
          <div class="section-card">
            <div class="section-header">
              <h3>User Reviews Management</h3>
              <div class="review-tabs">
                <button class="tab-btn active">All Reviews</button>
              </div>
            </div>

            <div class="reviews-list">
              <div v-if="reviewsLoading" class="loading">
                Loading reviews...
              </div>
              <div v-else-if="currentReviews.length === 0" class="no-reviews">
                No reviews found.
              </div>
              <div v-else class="reviews-grid">
                <div
                  v-for="review in currentReviews"
                  :key="review._id"
                  class="review-card"
                >
                  <div class="review-header">
                    <div class="user-info">
                      <div class="avatar">
                        {{ review.user.name.charAt(0).toUpperCase() }}
                      </div>
                      <div class="user-details">
                        <span class="user-name">{{ review.user.name }}</span>
                        <span class="user-email">{{ review.user.email }}</span>
                      </div>
                    </div>
                    <div class="review-rating">
                      <div class="stars">
                        <span
                          v-for="star in 5"
                          :key="star"
                          :class="{ filled: star <= review.rating }"
                          class="star"
                        >
                          ★
                        </span>
                      </div>
                      <span class="rating-text">{{ review.rating }}/5</span>
                    </div>
                  </div>

                  <div class="review-product">
                    <div class="product-info">
                      <img
                        v-if="review.product.imageFront"
                        :src="`/${review.product.imageFront}`"
                        alt="Product Image"
                        class="product-image"
                      />
                      <div class="product-details">
                        <span class="product-label">Product:</span>
                        <span class="product-name">{{
                          review.product.name
                        }}</span>
                        <span class="product-id"
                          >ID: {{ review.product._id }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="review-comment">
                    <p>{{ review.comment }}</p>
                  </div>

                  <div class="review-footer">
                    <span class="review-date">
                      {{ formatDate(review.createdAt) }}
                    </span>
                    <div class="review-actions">
                      <button
                        @click="deleteReview(review._id)"
                        class="btn-delete"
                        :disabled="actionLoading"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Change Password View -->
        <div
          v-if="selectedMenu === 'changePassword'"
          class="password-section-wrapper"
        >
          <div class="section-card password-card">
            <div class="section-header">
              <h3>Update Your Password</h3>
            </div>

            <form @submit.prevent="handleChangePassword" class="password-form">
              <div v-if="passwordError" class="alert error">
                {{ passwordError }}
              </div>
              <div v-if="passwordSuccess" class="alert success">
                {{ passwordSuccess }}
              </div>

              <div class="form-group">
                <label>Current Password</label>
                <div class="input-wrapper">
                  <span class="input-icon">🔒</span>
                  <input
                    type="password"
                    v-model="passwordForm.currentPassword"
                    required
                    placeholder="Enter current password"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>New Password</label>
                <div class="input-wrapper">
                  <span class="input-icon">🔑</span>
                  <input
                    type="password"
                    v-model="passwordForm.newPassword"
                    required
                    placeholder="Enter new password"
                  />
                </div>
                <small class="hint"
                  >At least 8 chars, uppercase, lowercase, number & special
                  char.</small
                >
              </div>

              <div class="form-group">
                <label>Confirm New Password</label>
                <div class="input-wrapper">
                  <span class="input-icon">✅</span>
                  <input
                    type="password"
                    v-model="passwordForm.confirmPassword"
                    required
                    placeholder="Confirm new password"
                  />
                </div>
              </div>

              <div class="form-actions">
                <button
                  type="submit"
                  class="btn-primary"
                  :disabled="passwordLoading"
                >
                  <span v-if="passwordLoading">Updating...</span>
                  <span v-else>Update Password</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>

    <!-- Modals -->
    <div
      v-if="showAddProductModal"
      class="modal-backdrop"
      @click="showAddProductModal = false"
    >
      <div class="modal-panel" @click.stop>
        <div class="modal-header">
          <h3>Add New Product</h3>
          <button class="close-btn" @click="showAddProductModal = false">
            ×
          </button>
        </div>
        <div class="modal-body">
          <AddProduct :is-modal="true" @close="closeAddProductModal" />
        </div>
      </div>
    </div>

    <div
      v-if="showEditProductModal"
      class="modal-backdrop"
      @click="showEditProductModal = false"
    >
      <div class="modal-panel" @click.stop>
        <div class="modal-header">
          <h3>Edit Product</h3>
          <button class="close-btn" @click="showEditProductModal = false">
            ×
          </button>
        </div>
        <div class="modal-body">
          <ProductEdit
            :product-id="editProductId"
            @updated="handleProductUpdated"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/AdminPage.css";
import logo from "@/assets/logo.jpeg";
import axios from "@/utils/axios";
import socket from "@/socket";
import AddProduct from "@/views/AddProduct.vue";
import ProductList from "@/views/ProductList.vue";
import ProductEdit from "@/views/ProductEdit.vue";
import ProductCategory from "@/views/AddCategory.vue";
import StaffManagement from "@/views/StaffManagement.vue";
// eslint-disable-next-line no-unused-vars
import AdminOrders from "@/views/AdminOrders.vue";
import AdminLeaves from "@/views/AdminLeaves.vue";
import ChatWindow from "@/views/ChatWindow.vue";
import LiveTracking from "@/views/LiveTracking.vue";
import AdminAttendance from "@/views/AdminAttendance.vue";
import AttendanceAnalysis from "@/views/AttendanceAnalysis.vue";
import AlgorithmComparison from "@/views/AlgorithmComparison.vue";

const API_BASE_URL = "/api";

export default {
  name: "AdminPage",
  components: {
    AddProduct,
    ProductList,
    ProductEdit,
    ProductCategory,
    StaffManagement,
    AdminOrders,
    AdminLeaves,
    ChatWindow,
    LiveTracking,
    AdminAttendance,
    AttendanceAnalysis,
    AlgorithmComparison,
  },
  data() {
    return {
      selectedMenu: "dashboard",
      isSidebarOpen: true,
      showAddProductModal: false,
      showListProductsModal: false,
      showEditProductModal: false,
      editProductId: null,
      dashboardLoading: false,

      // Stats
      totalProducts: 0,
      totalCategories: 0,
      totalStaff: 0,
      activeStaff: 0,
      pendingLeaves: 0,
      approvedLeaves: 0,
      totalInventory: 0,
      unreadMessageCount: 0,
      totalEnquiries: 0,
      pendingReviews: 0,
      totalPurchases: 0,
      totalProfit: 0,
      totalOrders: 0,
      salesTimeframe: "all",
      analyticsData: null,
      chartTimeframe: "today",
      displayedPurchases: 0,
      displayedProfit: 0,
      productOverview: [],
      productOverviewLoading: false,
      reviewsLoading: false,
      currentReviews: [],
      actionLoading: false,
      reportLoading: false,
      messageInterval: null,
      topProductsInterval: null,

      // Top Products
      topProducts: [],
      topProductsLoading: false,

      // Expiry & Alerts
      expiringProducts: [],
      expiredCount: 0,
      showExpiryDetails: false,

      // Analytics
      salesChartType: "table",
      customStartDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0],
      customEndDate: new Date().toISOString().split("T")[0],

      // Password Change
      passwordForm: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordError: "",
      passwordSuccess: "",
      passwordLoading: false,
      logo,
    };
  },
  mounted() {
    // Initialize sidebar state based on screen width
    if (window.innerWidth <= 1024) {
      this.isSidebarOpen = false;
    }
    this.fetchDashboardStats();
    this.fetchUnreadMessages();
    this.fetchTopProducts();
    this.fetchProductOverview();
    this.messageInterval = setInterval(() => {
      this.fetchUnreadMessages();
    }, 10000);
    this.topProductsInterval = setInterval(() => {
      this.fetchTopProducts();
    }, 30000);

    // Socket listeners for real-time updates
    socket.on("productAdded", () => {
      this.fetchDashboardStats();
    });

    socket.on("productUpdated", () => {
      this.fetchDashboardStats();
    });

    socket.on("productDeleted", () => {
      this.fetchDashboardStats();
    });

    socket.on("categoryAdded", () => {
      this.fetchDashboardStats();
    });

    socket.on("categoryUpdated", () => {
      this.fetchDashboardStats();
    });

    socket.on("categoryDeleted", () => {
      this.fetchDashboardStats();
    });

    socket.on("orderPlaced", () => {
      this.fetchDashboardStats();
      this.fetchTopProducts();
    });
  },
  beforeUnmount() {
    if (this.messageInterval) clearInterval(this.messageInterval);
    if (this.topProductsInterval) clearInterval(this.topProductsInterval);

    // Remove socket listeners
    socket.off("productAdded");
    socket.off("productUpdated");
    socket.off("productDeleted");
    socket.off("categoryAdded");
    socket.off("categoryUpdated");
    socket.off("categoryDeleted");
    socket.off("orderPlaced");
  },
  watch: {
    selectedMenu(newVal) {
      if (newVal === "reviews") {
        this.fetchReviews();
      }
      if (newVal === "dashboard") {
        this.fetchDashboardStats();
      }
    },
    totalPurchases() {
      // data updated, table re-renders reactively
    },
    chartTimeframe(newVal) {
      if (newVal === "today") {
        this.fetchDashboardStats();
      }
    },
  },
  methods: {
    async fetchProductOverview() {
      this.productOverviewLoading = true;
      try {
        const res = await axios.get(
          `${API_BASE_URL}/orders/admin/product-overview`
        );
        if (res.data.success) {
          this.productOverview = res.data.overview;
        }
      } catch (e) {
        console.error("fetchProductOverview error:", e);
      } finally {
        this.productOverviewLoading = false;
      }
    },
    async fetchTopProducts() {
      this.topProductsLoading = this.topProducts.length === 0;
      try {
        const res = await axios.get(
          `${API_BASE_URL}/orders/admin/top-products`
        );
        if (res.data && res.data.topProducts) {
          this.topProducts = res.data.topProducts;
        }
      } catch (e) {
        console.error("fetchTopProducts error:", e);
      } finally {
        this.topProductsLoading = false;
      }
    },
    getImageUrl(path) {
      if (!path)
        return "https://via.placeholder.com/48x48/f1f5f9/94a3b8?text=N%2FA";
      // If path already starts with / or http, use it as is
      if (path.startsWith("/") || path.startsWith("http")) return path;
      // Otherwise add leading slash
      return `/${path}`;
    },
    manageProduct(productId) {
      this.editProductId = productId;
      this.showEditProductModal = true;
    },
    handleTimeframeChange() {
      this.fetchDashboardStats();
    },
    async downloadReport() {
      this.reportLoading = true;
      try {
        let url = `${API_BASE_URL}/orders/admin/generate-report?timeframe=${this.chartTimeframe}`;
        if (this.chartTimeframe === "custom") {
          url += `&startDate=${this.customStartDate}&endDate=${this.customEndDate}`;
        }

        const response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `sales_report_${this.chartTimeframe}_${
          new Date().toISOString().split("T")[0]
        }.pdf`;
        link.click();
      } catch (e) {
        console.error("Download error:", e);
        alert("Failed to generate report");
      } finally {
        this.reportLoading = false;
      }
    },
    initCharts() {
      // Charts are no longer used in this view
      return;
    },
    getPageTitle(menu) {
      const titles = {
        dashboard: "Dashboard Overview",
        addProduct: "Add New Product",
        listProducts: "Product Catalog",
        addCategory: "Category Management",
        staffManagement: "Staff Management",
        orders: "Order Management",
        "approve-leaves": "Leave Requests",
        chat: "Messages & Communications",
        changePassword: "Change Password",
        tracking: "Live Vehicle Tracking",
        attendance: "Staff Attendance Monitoring",
        "attendance-analysis": "Attendance Analysis & Trends",
        "algorithm-comparison": "ML Algorithm Comparative Analysis",
      };
      return titles[menu] || "Dashboard";
    },
    selectMenu(menu) {
      this.selectedMenu = menu;
      this.isSidebarOpen = false;
    },
    openAddProductModal() {
      this.showAddProductModal = true;
      this.isSidebarOpen = false;
    },
    openListProductsModal() {
      this.showListProductsModal = true;
      this.isSidebarOpen = false;
    },
    async handleChangePassword() {
      this.passwordError = "";
      this.passwordSuccess = "";

      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.passwordError = "New passwords do not match.";
        return;
      }

      this.passwordLoading = true;

      try {
        const res = await axios.post(`${API_BASE_URL}/auth/change-password`, {
          currentPassword: this.passwordForm.currentPassword,
          newPassword: this.passwordForm.newPassword,
        });

        this.passwordSuccess = res.data.msg || "Password changed successfully.";
        this.passwordForm = {
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        };
      } catch (err) {
        this.passwordError =
          err.response?.data?.msg || "Failed to change password.";
      } finally {
        this.passwordLoading = false;
      }
    },
    async fetchDashboardStats() {
      this.dashboardLoading = true;
      try {
        let salesUrl = `${API_BASE_URL}/orders/admin/sales-analytics?timeframe=${this.chartTimeframe}`;
        if (this.chartTimeframe === "custom") {
          salesUrl += `&startDate=${this.customStartDate}&endDate=${this.customEndDate}`;
        } else if (this.chartTimeframe === "today") {
          salesUrl += `&date=${new Date().toISOString().split("T")[0]}`;
        }

        const [
          productsRes,
          categoriesRes,
          staffRes,
          leavesRes,
          reviewsRes,
          salesRes,
        ] = await Promise.all([
          axios.get(`${API_BASE_URL}/products/getproduct`),
          axios.get(`${API_BASE_URL}/categories`),
          axios.get(`${API_BASE_URL}/staff`),
          axios.get(`${API_BASE_URL}/leaves/all`),
          axios.get(`${API_BASE_URL}/reviews/admin/pending`),
          axios.get(salesUrl),
        ]);

        if (productsRes.data.success && productsRes.data.products) {
          this.totalProducts = productsRes.data.products.length;
          this.totalInventory = productsRes.data.products.reduce(
            (sum, p) => sum + (p.quantity || 0),
            0
          );

          // Expiry logic
          const now = new Date();
          const tenDaysLater = new Date(
            now.getTime() + 10 * 24 * 60 * 60 * 1000
          );

          this.expiringProducts = productsRes.data.products.filter((p) => {
            const exp = new Date(p.expiryDate);
            return exp > now && exp <= tenDaysLater;
          });

          this.expiredCount = productsRes.data.products.filter((p) => {
            return new Date(p.expiryDate) < now;
          }).length;
        }

        if (Array.isArray(categoriesRes.data)) {
          this.totalCategories = categoriesRes.data.length;
        }

        if (staffRes.data.success && Array.isArray(staffRes.data.staff)) {
          this.totalStaff = staffRes.data.staff.length;
          this.activeStaff = staffRes.data.staff.filter(
            (s) => s.status === "active"
          ).length;
        }

        if (Array.isArray(leavesRes.data)) {
          this.pendingLeaves = leavesRes.data.filter(
            (l) => l.status === "Pending"
          ).length;
          this.approvedLeaves = leavesRes.data.filter(
            (l) => l.status === "Approved"
          ).length;
        }

        if (Array.isArray(reviewsRes.data)) {
          this.pendingReviews = reviewsRes.data.length;
        }

        if (salesRes.data) {
          this.analyticsData = salesRes.data;
          this.totalPurchases = salesRes.data.totalPurchases || 0;
          this.totalProfit = salesRes.data.totalProfit || 0;
          this.totalOrders = salesRes.data.totalOrders || 0;
        }

        this.$nextTick(() => {
          this.initCharts();
        });
      } catch (error) {
        console.error("Error loading stats:", error);
      } finally {
        this.dashboardLoading = false;
      }
    },
    async fetchUnreadMessages() {
      try {
        const res = await axios.get("/api/messages/unread-count");
        if (res.data.success) this.unreadMessageCount = res.data.unreadCount;
      } catch (e) {
        console.error("Msg Error", e);
      }
    },
    async logout() {
      try {
        await axios.post("/api/auth/logout");
      } catch (err) {
        console.error("Logout error:", err);
      } finally {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        this.$router.push("/");
      }
    },
    closeAddProductModal() {
      this.showAddProductModal = false;
      this.fetchDashboardStats();
    },
    closeListProductsModal() {
      this.showListProductsModal = false;
      this.fetchDashboardStats();
    },
    openEditProductModal(id) {
      this.editProductId = id;
      this.showEditProductModal = true;
    },
    handleProductUpdated() {
      this.showEditProductModal = false;
      this.showListProductsModal = false;
      this.fetchDashboardStats();
    },
    async fetchReviews() {
      this.reviewsLoading = true;
      try {
        const res = await axios.get("/api/reviews/admin/all");
        if (res.data.success) {
          this.currentReviews = res.data.reviews;
        }
      } catch (err) {
        console.error("Error fetching reviews:", err);
      } finally {
        this.reviewsLoading = false;
      }
    },
    async deleteReview(id) {
      if (!confirm("Are you sure you want to delete this review?")) return;
      this.actionLoading = true;
      try {
        const res = await axios.delete(`/api/reviews/admin/delete/${id}`);
        if (res.data.success) {
          this.fetchReviews();
          this.fetchDashboardStats();
        }
      } catch (err) {
        console.error("Error deleting review:", err);
        alert("Failed to delete review");
      } finally {
        this.actionLoading = false;
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },
};
</script>
